import * as React from 'react'
import { Button, Paper, Snackbar, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import LockRoundedIcon from '@mui/icons-material/LockRounded'
import { floatingSurfaceStyles } from '../../theme/floatingSurface'

const AUTO_HIDE_DURATION_MS = 5000
const ACCESS_MESSAGE = 'Detalle solo para cuentas autorizadas.'
const CONTACT_LABEL = 'Contáctanos'
const SNACKBAR_ANCHOR = { vertical: 'bottom', horizontal: 'center' }

// Sin anchorPosition se usa la posición inferior centrada por defecto de MUI.
// '&&' eleva la especificidad para ganar a los estilos responsive del Snackbar.
const buildPositionSx = anchorPosition =>
  anchorPosition
    ? {
        '&&': {
          bottom: anchorPosition.bottom,
          left: anchorPosition.centerX,
          right: 'auto',
          transform: 'translateX(-50%)',
          width: 'max-content',
          maxWidth: 'calc(100vw - 16px)',
        },
      }
    : {}

const AccessRestrictedSnackbar = ({ open, onClose, onContact, anchorPosition = null }) => (
  <Snackbar
    open={open}
    autoHideDuration={AUTO_HIDE_DURATION_MS}
    onClose={onClose}
    anchorOrigin={SNACKBAR_ANCHOR}
    sx={{ zIndex: 9999, ...buildPositionSx(anchorPosition) }}>
    <Paper
      role="alert"
      elevation={0}
      sx={theme => ({
        ...floatingSurfaceStyles(theme),
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 0.5,
        pl: 1.5,
        pr: 1,
        borderRadius: 999,
      })}>
      <LockRoundedIcon sx={{ fontSize: 16, color: 'secondary.light' }} />
      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.8rem', lineHeight: 1.35 }}>
        {ACCESS_MESSAGE}
      </Typography>
      <Button
        size="small"
        onClick={onContact}
        sx={theme => ({
          color: theme.palette.secondary.light,
          fontWeight: 600,
          textTransform: 'none',
          whiteSpace: 'nowrap',
          // El min-width de MUI permite encogerlo por debajo del texto; que se ajuste el mensaje.
          flexShrink: 0,
          borderRadius: 999,
          '&:hover': { bgcolor: alpha(theme.palette.common.white, 0.1) },
        })}>
        {CONTACT_LABEL}
      </Button>
    </Paper>
  </Snackbar>
)

export default AccessRestrictedSnackbar
